<template>

  <div >
    <div class="content-example"></div>
    <div class="footer-access">
      <div class="condition-color">
        <img src="@/assets/images/guardian/Logo_accesspark.png"/>
        <a href="https://accesspark.co/tratamiento_datos.html">Terminos y condiciones</a>
        <a href="https://accesspark.co/contactenos.html">Ayuda</a>
        <img src="@/assets/images/guardian/in.png" alt=""/>
        <img src="@/assets/images/guardian/facebook.png" alt=""/>
        <img src="@/assets/images/guardian/instagran.png" alt=""/>
        <div Class="content-power">
          <span>Power by accesspark SAS</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterPage"
}
</script>

<style scoped>


.content-example {
  display: flex;

}
.footer-access {
  display: flex;
  background-color: #FFFFFF;
  justify-content: center;
}
.condition-color a{
  color: #223354;
  opacity: 0.5;
  margin-right: 19px;
}

.condition-color img{
  margin-right: 10px;
  margin-top: 1px;
}
.content-power{
  display: flex;
  justify-content: center;
}


</style>